// @flow
import Resource from 'speed-js-core/src/api/Resource';
import type NestedResource from 'speed-js-core/src/api/NestedResource';
import ProfileChannelResource from './ProfileChannelResource';

export default class ProfileResource extends Resource {
    basePath: string = 'accounts/profiles/';

    objectPath: string = 'accounts/profiles/{ident}/';

    nestedResources: { [string]: Class<NestedResource> } = {
        channels: ProfileChannelResource,
    };

    addToDevices(id: string, data): Promise<Object> {
        return this.client._request(`${this._getObjectPath(id)}add_to_devices/`, 'PATCH', data);
    }

    resetOrder(id: string): Promise<Object> {
        return this.client._request(`${this._getObjectPath(id)}reset_order/`, 'PATCH');
    }
}
